export const SENTRY_REPLAY_NETWORK_DETAIL_ALLOW_URLS: string[] = [];

export const SENTRY_REPLAY_NETWORK_DETAIL_DENY_URLS = [
  '/api/mexc-distributor/',
  '/api/binance-distributor/',
];
